import { UseMutationOptions, UseMutationResult, UseQueryOptions, UseQueryResult, useMutation, useQuery } from 'react-query';
import { axiosClient, url } from '../';
import { AxiosError } from 'axios';
import { AgeGroup, ErrorObject, KYBStatus } from './../common.types';


export function useCheckKYBStatus<
  TSelectData = {
    status: KYBStatus;
    ageGroup: AgeGroup;
  },
  TError = AxiosError<ErrorObject>,
>(
  options?: Omit<UseQueryOptions<void, TError, TSelectData>, 'queryKey' | 'queryFn'> | undefined,
): UseQueryResult<TSelectData, TError> {
  return useQuery<void, TError, TSelectData>(
    ['CheckKYBStatus'],
    () => axiosClient.get(url.kybController.checkStatus),
    options,
  );
}

export function useSubmitKYB<TContext>(
    options?: Omit<UseMutationOptions<void, AxiosError<ErrorObject>, void, TContext>, 'mutationKey' | 'mutationFn'>,
  ): UseMutationResult<void, AxiosError<ErrorObject>, void, TContext> {
    const key = ['SubmitKYB'];
  
    return useMutation(() => axiosClient.post(url.kybController.submitKYB), {
      ...options,
      mutationKey: key,
    });
  }